import { createContext, useState } from 'react';
import { MessageContextType } from '../types/messageContextType';
import IUserMessage from '../models/iUserMessage';
import IBotMessage from '../models/iBotMessage';
import IGeminiChat from '../models/iGeminiChat';

export const MessageContext = createContext<MessageContextType>(
  {} as MessageContextType
);

interface IMessageContextProviderProps extends React.PropsWithChildren {}

export const MessageContextProvider = (props: IMessageContextProviderProps) => {
  const [messages, setMessages] = useState<(IUserMessage | IBotMessage)[]>([]);
  const [chatId, setChatId] = useState<string | undefined>();
  const [isLlmQueryLoading, setIsLlmQueryLoading] = useState(false);
  const [geminiChat, setGeminiChat] = useState<IGeminiChat[]>([]);
  const [isGeminiLoading, setIsGeminiLoading] = useState(false);

  return (
    <MessageContext.Provider
      value={{
        messages,
        setMessages,
        chatId,
        setChatId,
        isLlmQueryLoading,
        setIsLlmQueryLoading,
        geminiChat,
        setGeminiChat,
        isGeminiLoading,
        setIsGeminiLoading,
      }}
    >
      {props.children}
    </MessageContext.Provider>
  );
};
